<script>
import CrmAPI from 'dashboard/api/integrations/crm';

export default {
  props: {
    modelValue: {
      type: [Array, Object],
      default: () => [],
    },
  },
  emits: ['update:modelValue'],
  data() {
    return {
      funnels: [],
      loadingFunnels: false,
      crmIntegrationId: 'welloncrm',
    };
  },
  computed: {
    actionParams() {
      if (Array.isArray(this.modelValue)) {
        return this.modelValue[0] || {};
      }

      return this.modelValue || {};
    },
    selectedFunnel: {
      get() {
        return (
          this.funnels.find(
            funnel => String(funnel.id) === String(this.actionParams.funnel_id)
          ) || null
        );
      },
      set(funnel) {
        this.updateActionParams({
          funnel_id: funnel ? funnel.id : null,
          stage_id: null,
        });
      },
    },
    stageOptions() {
      return this.selectedFunnel?.deal_stages || [];
    },
    selectedStage: {
      get() {
        if (!this.selectedFunnel) return null;

        return (
          this.stageOptions.find(
            stage => String(stage.id) === String(this.actionParams.stage_id)
          ) || null
        );
      },
      set(stage) {
        this.updateActionParams({
          funnel_id: this.selectedFunnel ? this.selectedFunnel.id : null,
          stage_id: stage ? stage.id : null,
        });
      },
    },
    hasFunnels() {
      return this.funnels.length > 0;
    },
  },
  mounted() {
    this.loadFunnels();
  },
  methods: {
    updateActionParams(params) {
      this.$emit('update:modelValue', params);
    },
    async loadFunnels() {
      this.loadingFunnels = true;

      try {
        const crmApi = new CrmAPI(this.crmIntegrationId);
        const response = await crmApi.getFunnels();
        const funnels = Array.isArray(response.data) ? response.data : [];

        this.funnels = funnels.map(funnel => ({
          id: funnel.id,
          name: funnel.name,
          deal_stages: funnel.deal_stages || [],
        }));
      } catch (error) {
        this.funnels = [];
      } finally {
        this.loadingFunnels = false;
      }
    },
  },
};
</script>

<template>
  <div class="create-lead-action">
    <div
      v-if="loadingFunnels"
      class="text-xs text-slate-600 dark:text-slate-300"
    >
      {{ $t('AUTOMATION.ACTION.CREATE_LEAD_LOADING') }}
    </div>
    <div
      v-else-if="!hasFunnels"
      class="text-xs text-slate-600 dark:text-slate-300"
    >
      {{ $t('AUTOMATION.ACTION.CREATE_LEAD_EMPTY') }}
    </div>
    <div v-else class="create-lead-action__fields">
      <label class="create-lead-action__label">
        {{ $t('AUTOMATION.ACTION.CREATE_LEAD_FUNNEL_LABEL') }}
      </label>
      <div class="multiselect-wrap--small">
        <multiselect
          v-model="selectedFunnel"
          track-by="id"
          label="name"
          :placeholder="$t('AUTOMATION.ACTION.CREATE_LEAD_FUNNEL_PLACEHOLDER')"
          selected-label
          :select-label="$t('FORMS.MULTISELECT.ENTER_TO_SELECT')"
          deselect-label=""
          :max-height="160"
          :options="funnels"
          :allow-empty="false"
          :option-height="104"
        />
      </div>

      <label class="create-lead-action__label">
        {{ $t('AUTOMATION.ACTION.CREATE_LEAD_STAGE_LABEL') }}
      </label>
      <div class="multiselect-wrap--small">
        <multiselect
          v-model="selectedStage"
          track-by="id"
          label="name"
          :placeholder="$t('AUTOMATION.ACTION.CREATE_LEAD_STAGE_PLACEHOLDER')"
          selected-label
          :select-label="$t('FORMS.MULTISELECT.ENTER_TO_SELECT')"
          deselect-label=""
          :max-height="160"
          :options="stageOptions"
          :allow-empty="false"
          :disabled="!selectedFunnel || !stageOptions.length"
          :option-height="104"
        />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.create-lead-action {
  @apply mt-2;
}

.create-lead-action__fields {
  @apply flex flex-col gap-2;
}

.create-lead-action__label {
  @apply block text-xs font-medium mb-1;
}
</style>
